// extracted by mini-css-extract-plugin
module.exports = {"shippingAlert":"ShippingAlert_shippingAlert__0QqQL","textSmall":"ShippingAlert_textSmall__1ICRe"};